let score;
let quizResultsData = [];
const quiz = document.getElementById('quiz');
const quizScores = Array.from(document.querySelectorAll('.quiz__question-score '));
const getResultsButton = document.getElementById('get-quiz-results');
const quizResults = document.getElementById('quiz-results');
const quizResultsElement = document.getElementById('quiz-results-container');

if(getResultsButton){
    getResultsButton.addEventListener('click',event=>{
        let metadata = null;
        const email = getResultsButton.dataset.email;
        const first = getResultsButton.dataset.first;
        const last = getResultsButton.dataset.last;
        if(email){
            metadata = {
                '$email' : email
            }
        }
        if(first){
            metadata['$first_name'] = first;
        }
        if(last){
            metadata['$last_name'] = last;
        }
        getQuizResults(metadata);
    });
}
    
// get range sliders
const quizSliders = Array.from(document.querySelectorAll('input[type="range"]'));
if( quizSliders.length > 0 ){
    // add event listeners
    quizSliders.forEach((quizSlider,index) => {
        quizSlider.addEventListener('input',()=>{
            // set question value
            quizScores[index].dataset.value = quizSlider.value;
            
        });
    });
}

// get results data
function setQuizResultsData (){
    quizSliders.forEach(quizSlider => {
        quizResultsData.push({
            "name" : quizSlider.getAttribute('name'),
            "value" : quizSlider.value
        });
    });
}


// calculate quiz score
function getQuizScore (){
    score = 0;
    quizResultsData.forEach(result => {
        score += Number(result.value);
    });
    return score;
}

function getQuizResults(metaData = null){
    setQuizResultsData();
    if(quiz && quizResults && quizResultsElement && scoreLevels ){
        const level = getLeadershipLevel(getQuizScore(),scoreLevels);
        if(level){
            quizResultsElement.innerHTML = `
            <div class="mb-desktop-20 mb-mobile-20">
                <h2>Your Score: ${getQuizScore()}/100</h2>
            </div>
            <div class="mt-desktop-20 mb-desktop-50 mt-mobile-20 mb-mobile-40">
                <div class="mt-desktop-20 mb-desktop-20 mt-mobile-20 mb-mobile-20"><h2 class="heading--ultra">${level.label}</h2></div>
                <h3>${level.description}</h3>
            </div>
            `;
            quizResults.classList.add('fade-in-fast');
            quiz.dataset.state = 'completed';
            window.scrollTo(0, 0);
        }
    }
    if(metaData){
        saveResultsToGoogleSheet(metaData);
    }
    
}   

function getLeadershipLevel(score, levels) {
    for (let level of levels) {
      if (score >= Number(level.min_score) && score <= Number(level.max_score)) {
        return level;
      }
    }
    return null;
}

function saveResultsToGoogleSheet(data){
    // console.log(`saveResultsToGoogleSheet(): ${JSON.stringify(data)}`);
    // console.log(`quizResultsData:${JSON.stringify(quizResultsData)}`);

    // convert results array into object 
    let sheetData = quizResultsData.reduce((acc, curr) => {
        acc[curr.name] = curr.value;
        return acc;
    }, {});

    // add personal data
    sheetData['email'] = data.$email;
    sheetData['first-name'] = data.$first_name ? data.$first_name : '';
    sheetData['last-name'] = data.$last_name ? data.$last_name : '';
    sheetData['score'] = getQuizScore();
    // console.log(`sheetData:${JSON.stringify(sheetData)}`);
    
    // submit to google sheets
    fetch('https://script.google.com/macros/s/AKfycbyWRb0yQUeladqOE2Jgub2C7SXHnQkKAr3QdKU-w-GHEEhnnZFky5v0zN8UrE_t4HGZqg/exec', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'text/plain;charset=utf-8'
        },
        body: JSON.stringify(sheetData)
    })
    .then(response => {
        if (response.ok) {
            console.log('google data saved');
        } else {
            console.error('Failed to save google data');
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });

}

export {
    quiz, getQuizResults
}